import React from "react";
import {CheckBox} from "@unibuddy/patron";
import {Constants, useTranslation} from "@unibuddy/intl";
import ReactMarkdown from "react-markdown";

import {getCustomTextInLocale} from "shared/Utils/LocaleUtils";
import ThemedLink from "shared/Navigation/components/ThemedLink/ThemedLink";

import {useUniversity} from "../../../UniversityProvider/UniversityProvider";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_UPDATED_MARKETING_CONSENT} from "../../../../../translations/privacy-text";

export function InstitutionMarketingConsent() {
    const {t, i18n} = useTranslation(IntlNamespaces.PRIVACY_TEXT);
    const {customMarketingConsentTextInLocales} = useUniversity();

    const lang = i18n.language || Constants.DEFAULT_LOCALE;
    const customMarketingConsentText = getCustomTextInLocale(
        customMarketingConsentTextInLocales ?? [],
        lang,
    );
    return (
        <CheckBox name="acceptMarketing" id="acceptMarketing">
            {customMarketingConsentText ? (
                <ReactMarkdown
                    source={customMarketingConsentText}
                    renderers={{
                        link: ({href, children, nodeKey}) => (
                            <ThemedLink key={nodeKey} external to={href} target="_blank">
                                {children}
                            </ThemedLink>
                        ),
                    }}
                />
            ) : (
                t(INTL_UPDATED_MARKETING_CONSENT.key, INTL_UPDATED_MARKETING_CONSENT.defaultValue)
            )}
        </CheckBox>
    );
}
